//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { SessionMode } from '@moderation-mode/constants/SessionMode';

const buildKey = (userId: string, clientId: string) =>
  `moderationMode:${userId}:${clientId}`;

const isSessionMode = (value: string | null): value is SessionMode =>
  value === SessionMode.Client || value === SessionMode.Moderator;

export const readStoredMode = (
  userId: string,
  clientId: string,
): SessionMode | undefined => {
  try {
    const stored = window.localStorage.getItem(buildKey(userId, clientId));
    return isSessionMode(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
};

export const writeStoredMode = (
  userId: string,
  clientId: string,
  mode: SessionMode,
): void => {
  try {
    window.localStorage.setItem(buildKey(userId, clientId), mode);
  } catch {
    // Non-fatal: mode won't persist across reloads in private browsing
  }
};
